var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-trails"},_vm._l((_vm.list),function(trail){return _c('router-link',{key:trail.id,attrs:{"to":{
      name: 'trail',
      params: { id: trail.id, slug: _vm.slugfy(trail.name) }
    }}},[_c('div',{staticClass:"img-wrapper mb-3"},[_c('img',{attrs:{"src":trail.picture}})]),_c('span',{style:({ color: trail.color })},[_vm._v(_vm._s(trail.name))])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }